module.exports = __webpack_public_path__ + "static/media/Orinocco23.4f482216.jpg";